import { resolvePhotoUrl } from "../../utils/profilePhoto";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {  
  Share2,
  Bookmark,
  UserRound,
} from "lucide-react";
import photolg from "../../assets/img/photo-1.jpg";
import userimg from "../../assets/img/user-img.png";
import star from "../../assets/img/star.svg";
import RedButton from "../RedButton";
import dummyProfile from "../../assets/img/dummy_profile.png";
import ticIcon from "../../assets/img/tic_icon.svg";

const PeopleViewCard = ({item, isActive}) => { 
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
          
    useEffect(() => {
      const token = localStorage.getItem("token");
      if (token) {
        setIsLoggedIn(true);
      }
    }, []);

    const name = item.first_name 
      ? `${item.first_name} ${item.middle_name ? item.middle_name + " " : ""}${item.last_name || ""}`.trim()
      : (item.name || "N/A");

    const role = item.job_title || item.role || "Professional";
    const company = item.company_name || item.company || "N/A";
    const industry = item.industry || "N/A";

    const locationParts = [];
    if (item.city) locationParts.push(item.city);
    if (item.state) locationParts.push(item.state);
    if (item.country) locationParts.push(item.country);
    const location = locationParts.length > 0 ? locationParts.join(", ") : (item.location || "N/A");

    const skills = Array.isArray(item.skills) 
      ? item.skills 
      : (item.industry ? [item.industry] : ["General"]);

    const activeState = isActive !== undefined ? isActive : (item.isActive ?? true);

    const profileImgUrl = resolvePhotoUrl(item.profile_photo);

    return (
        <>
        <div className="sr-result-card">
            <div className="row g-3 align-items-center">
                <div className="col-12 col-sm-auto">
                <img 
                  src={profileImgUrl} 
                  alt={name} 
                  style={{ width: "48px", height: "48px", borderRadius: "50%", objectFit: "cover" }} 
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = dummyProfile;
                  }}
                />
                </div>

                <div className="col-12 col-sm">
                <div className="d-flex align-items-center justify-content-between gap-3">
                    <div>
                    <h2 className="sr-result-title d-flex align-items-center gap-2" style={{ margin: 0 }}>
                      {name}
                      {activeState && (
                        <img src={ticIcon} alt="Verified" style={{ width: "16px", height: "16px" }} />
                      )}
                    </h2>
                    <p className="sr-result-copy mt-1">
                        {role} at {company}
                    </p>
                    </div>
                    <div className="activeusrbox">
                    <div className={`user-status ${activeState ? "active" : "inactive"}`}>
                        <span className="status-dot"></span>
                        <span>{activeState ? "ACTIVE NOW" : "NOT ACTIVE"}</span>
                    </div>
                    </div>
                </div>
                </div>

                <div className="col-12 mt-16"> 
                <div className="row g-2">                   
                    <div className="col-12 col-sm-4">
                    <div className="bggraycol2 px-4 py-3 rounded-4 h-100">                        
                        <div className="text-uppercase ft-11 graytext">
                        Company
                        </div>

                        <div className="fw-bold ft-14 graytext">
                        {company}
                        </div>
                    </div>
                    </div>
                    <div className="col-12 col-sm-4">
                    <div className="bggraycol2 px-4 py-3 rounded-4 h-100">                        
                        <div className="text-uppercase ft-11 graytext">
                        Industry
                        </div>

                        <div className="fw-semibold ft-14">
                        {industry}
                        </div>
                    </div>
                    </div>

                    <div className="col-12 col-sm-4">
                    <div className="bggraycol2 px-4 py-3 rounded-4 h-100">                        
                        <div className="text-uppercase ft-11 graytext">
                        Location
                        </div>

                        <div className="fw-semibold ft-14">
                        {location}
                        </div>
                    </div>
                    </div>

                        
                </div>               
                </div>



                <div className="col-12 mt-16">
                    
                    {isLoggedIn ? (

                        <div className="d-flex align-items-center justify-content-between">

                            <div className="d-flex gap-2 items-center">
                            
                            <Link to="/"                        
                                className="btn border-0 rounded-3 d-flex align-items-center justify-content-center"
                                style={{
                                width: "40px",
                                height: "40px",
                                background: "#FFF4F4",
                                }}
                            >
                                <Share2 size={18} color="#2F343B" />
                            </Link>

                            <Link to="/"
                                className="btn border-0 rounded-3 d-flex align-items-center justify-content-center"
                                style={{
                                width: "40px",
                                height: "40px",
                                background: "#FFF4F4",
                                }}
                            >
                                <Bookmark size={18} color="#2F343B" />
                            </Link>

                            </div>

                            <RedButton
                                btntext="View Profile"
                                name="viewProfile"
                            />

                        </div>

                        ) : (
                        <div className="d-flex align-items-center justify-content-between p-3 rounded-3"
                            style={{
                                background: "#FFF1F1",
                                border: "1px solid #F5D6D6",
                            }}
                            >
                            <div className="d-flex align-items-center gap-2">
                                <UserRound size={14} color="#6B7280" />

                                <span
                                className="fw-semibold"
                                style={{
                                    color: "#6B7280",
                                    fontSize: "13px",
                                }}
                                >
                                Sign Up To Unlock Full Details, Eligibility And Insights.
                                </span>
                            </div>

                            <RedButton
                                btntext="Unlock Full Details"
                                name="unlockFullDetails"
                                onClick={() => navigate("/")}
                            />

                        </div>                        
                        )
                    }  
                </div>

            </div>
            </div>        
        </>
    );
};

export default PeopleViewCard;
